<template>
	<PageContainer size="s">
		<AmeliproCard
			card-title="Mot de passe oublié"
			class="pa-6"
		>
			<VForm ref="form">
				<AmeliproTextField
					id="numeroIdentification"
					v-model="numeroIdentification"
					label="N° d’identification"
					aria-required
					validate-on-blur
					:rules="identifiantRules"
				/>
				<AmeliproTextField
					id="email"
					v-model="email"
					label="Adresse e-mail"
					aria-required
					validate-on-blur
					:rules="emailRules"
				/>
				<div class="d-flex flex-column flex-sm-row justify-sm-space-between">
					<AmeliproBtn
						class="mt-2 mt-sm-0"
						@click="goToPath('/login')"
					>
						Retour
					</AmeliproBtn>
					<AmeliproBtn
						class="mt-2 mt-sm-0"
						@click="submitRequestPassword"
					>
						Valider
					</AmeliproBtn>
				</div>
			</VForm>
		</AmeliproCard>
	</PageContainer>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';

	import { required } from '@cnamts/vue-dot/src/rules/required';
	import { maxLength } from '@cnamts/vue-dot/src/rules/maxLength';
	import { matchPattern } from '@cnamts/vue-dot/src/rules/matchPattern';
	import { emailFn } from '@cnamts/vue-dot/src/rules/email';
	import { Refs, VForm } from '@cnamts/vue-dot/src/types';
	import { requestPasswordApi } from '@/services/api/api';
	import { store } from '@/store';
	import UserMixin from '@/mixins/userMixin';
	import { Meta, MetaInfo } from '@/decorators';
	const MixinsDeclaration = mixins(UserMixin);

	@Component<ForgotPassword>({})
	export default class ForgotPassword extends MixinsDeclaration {
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: 'PEGASE - Mot de passe oublié' as string
			};
		}
		$refs!: Refs<{
			form: VForm;
		}>;

		// Règles de validation
		emailRules = [
			required,
			emailFn({
				default: 'Le format de l\'adresse e-mail n\'est pas valide.'
			})
		];
		patternIdentifiant = new RegExp('^(\\d{9}|\\d{11}|\\d{14})$');
		identifiantRules = [
			maxLength(14, false, {
				default:
					'Le N° d\'identification doit être une chaîne de caractères numériques de 9, 11 ou 14 caractères.'
			}),
			matchPattern(this.patternIdentifiant, {
				default:
					'Le N° d\'identification doit être une chaîne de caractères numériques de 9, 11 ou 14 caractères.'
			})
		];

		email = '';
		role = '';
		roles: string[] = ['Médecin', 'Officine', 'Mandataire'];
		typeIdentifiant = '';
		typeIdentifiants: string[] = ['N° AM', 'N° RPPS', 'N° FINESS', 'N° SIRET'];
		numeroIdentification = '';

		async submitRequestPassword(): Promise<void> {
			await this.$nextTick(); // attend la mise à jour du cycle de vie (dom)
			if (this.$refs.form.validate()) {
				try {
					// Appel api récupération mot de passe
					if (this.email) {
						const response = await requestPasswordApi({
							email: this.email,
							login: this.numeroIdentification
						});
						if (response && response.status === 200) {
							// Redirection vers la page de connexion
							this.$router.push({ name: 'login' });
							store.dispatch('notification/add', {
								type: 'success',
								message: response.data.message
							});
						} else {
							store.dispatch('notification/add', {
								type: 'error',
								message:
									'Une erreur est survenue lors de la demande de réinitialisation de mot de passe'
							});
						}
					}
				} catch (error) {
					store.dispatch('notification/add', {
						type: 'error',
						message:
							'Une erreur est survenue lors de la récupération de votre mot de passe'
					});
				}
			}
		}

		// new
	}
</script>
